export default [
  {
    autoValidate: true,
    componentName: 'StepIntro',
    isArianeFeedStep: false,
  },
  {
    autoValidate: false,
    componentName: 'StepSex',
    isArianeFeedStep: true,
  },
  {
    autoValidate: false,
    componentName: 'StepAge',
    isArianeFeedStep: true,
    defaultValidate: true,
  },
  {
    autoValidate: false,
    componentName: 'StepWeight',
    isArianeFeedStep: true,
    isSkippable: true,
    defaultValidate: true,
  },
  {
    autoValidate: false,
    componentName: 'StepWeekConsumption',
    isArianeFeedStep: true,
  },
  {
    autoValidate: false,
    componentName: 'StepDayConsumption',
    isArianeFeedStep: true,
    checkConsumptionDays: true,
  },
  {
    autoValidate: false,
    componentName: 'StepPrice',
    isArianeFeedStep: true,
    checkConsumptionDays: true,
  },
  {
    autoValidate: false,
    componentName: 'StepFinish',
    isArianeFeedStep: false,
  },
]



// WEBPACK FOOTER //
// ./src/constants/steps.ts